import React from 'react';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCheckCircle, faTimesCircle} from '@fortawesome/free-solid-svg-icons';

import {Loading} from 'Components/Partials';
import {Select} from 'Components/Form';

import VersionHistoryApi from 'Services/Api/Base/VersionHistory';

import {convertValue} from 'Services/BaseHelpers';

// Check out the Duality Portal "Add Version Control to Model" Wiki for guidance.

/*
Example...
<VersionHistory
    model_name="ProjectEnvironment"
    record_id={project_environment_id}
    columns={this.columns} // (Same columns structure as IndexTable)
/>
*/

export default class VersionHistory extends React.Component {
    /**
     * @var state
     */
    state = {
        loading: true,
        latest_version: null,
        version_1: null,
        version_2: null,
        version_1_data: null,
        version_2_data: null
    };

    /**
     * @method componentDidMount
     */
    componentDidMount() {
        this.loadData();
    }

    /**
     * @method loadData
     * @param {null|integer} version_1
     * @param {null|integer} version_2
     */
    loadData = async (version_1 = null, version_2 = null) => {
        const {model_name, record_id} = this.props;

        this.setState({
            loading: true
        });

        const response = await VersionHistoryApi.get(null, {
            model_name,
            record_id,
            version_1,
            version_2
        });

        this.setState({
            loading: false,
            latest_version: response?.data?.latest_version,
            version_1: response?.data?.version_1,
            version_2: response?.data?.version_2,
            version_1_data: response?.data?.version_1_data,
            version_2_data: response?.data?.version_2_data
        });
    }

    /**
     * @method getAvailableVersions
     * @return {array}
     */
    getAvailableVersions() {
        const {latest_version} = this.state;

        let versions = [];

        for (var i=1; i<=latest_version; i++) {
            versions.push({
                label: 'Version ' + i,
                value: i
            });
        }

        return versions;
    }

    /**
     * @method render
     * @return {JSX.Element}
     */
    render() {
        const {title} = this.props;
        const {loading, latest_version} = this.state;

        return (
            <div>
                {loading && <Loading/>}

                {!loading && latest_version === 1 && 
                    <p className="text-center font-bold">
                        No updates have been made.
                    </p>
                }

                {!loading && latest_version !== 1 &&this.renderVersions()}
            </div>
        );
    }

    /**
     * @method renderVersions
     * @return {JSX.Element}
     */
    renderVersions() {
        const {version_1, version_2, version_1_data, version_2_data} = this.state;
        const {columns} = this.props;

        let thStyle = 'border border-gray-500 px-4 py-2 bg-gray-400';
        let tdStyle = 'border border-gray-500 px-4 py-2 text-center';

        return (
            <table className="table-fixed mx-auto">
                <tbody>
                    <tr>
                        <th className={thStyle} />

                        <td className={tdStyle}>
                            {this.renderVersionSelect(1)}
                        </td>

                        <td className={tdStyle}>
                            {this.renderVersionSelect(2)}
                        </td>
                    </tr>

                    <tr>
                        <th className={thStyle}>
                            Version Created By
                        </th>

                        <td className={tdStyle}>
                            {version_1_data?.version_user?.full_name}
                        </td>

                        <td className={tdStyle}>
                            {version_2_data?.version_user?.full_name}
                        </td>
                    </tr>

                    <tr>
                        <th className={thStyle}>
                            Version Created At
                        </th>

                        <td className={tdStyle}>
                            {version_1_data?.version_created_at?.date_time_timezone}
                        </td>

                        <td className={tdStyle}>
                            {version_2_data?.version_created_at?.date_time_timezone}
                        </td>
                    </tr>

                    <tr>
                        <th className={thStyle}>
                            Deleted
                        </th>

                        <td className={tdStyle}>
                            <FontAwesomeIcon 
                                icon={version_1_data?.deleted ? faCheckCircle : faTimesCircle} 
                                className={`text-2xl ${version_1_data?.deleted ? 'text-green-400' : 'text-red-400'}`}
                            />
                        </td>

                        <td className={tdStyle}>
                            <FontAwesomeIcon 
                                icon={version_2_data?.deleted ? faCheckCircle : faTimesCircle} 
                                className={`text-2xl ${version_2_data?.deleted ? 'text-green-400' : 'text-red-400'}`}
                            />
                        </td>
                    </tr>

                    {columns.map((column, i) => (
                        <tr key={i}>
                            <th className={thStyle}>
                                {column.label}
                            </th>

                            <td className={tdStyle}>
                                {convertValue(column, version_1_data)}
                            </td>

                            <td className={tdStyle}>
                                {convertValue(column, version_2_data)}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    /**
     * @method renderVersionSelect
     * @param {integer} table
     * @return {JSX.Element}
     */
    renderVersionSelect(table) {
        const {version_1, version_2} = this.state;

        return (
            <Select
                placeholder="Version"
                value={table === 1 ? version_1 : version_2}
                onChange={(v) => {
                    if (table === 1)  {
                        this.loadData(v, version_2);
                    } else if (table === 2) {
                        this.loadData(version_1, v);
                    }
                }}
                options={this.getAvailableVersions()}
            />
        );
    }
}